import * as zod from 'zod';

export const MiraiTrainedSkill = zod.object({
  id: zod.number(),
  skillName: zod.string(),
  iterationName: zod.string(),
  createdAt: zod.string(),
});

export type MiraiTrainedSkill = zod.infer<typeof MiraiTrainedSkill>;

export const MiraiControllerState = zod.object({
  kind: zod.literal('MiraiController'),
  isConnected: zod.boolean(),
  // null = failed to fetch (controller unreachable); populated array = connected
  trainedSkills: zod.array(MiraiTrainedSkill).nullable(),
});

export type MiraiControllerState = zod.infer<typeof MiraiControllerState>;
